import { useQuery } from '@tanstack/react-query';
import { getListingRadar } from '../lib/apiClient';

// The radar runs once an hour; no need to poll faster.
const STALE_TIME_MS = 5 * 60_000;

/** Coinbase listing radar forward paper test. Hypothetical only. */
export function useListingRadar() {
  return useQuery({
    queryKey: ['listing-radar'],
    queryFn: getListingRadar,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
